import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { AuthProvider } from "./hooks/useAuth";
import { usePageTracking } from "./hooks/usePageTracking";
import i18n from "./i18n";

function AppRoutesWithTracking() {
  usePageTracking();
  return <AppRoutes />;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutesWithTracking />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;